import React, { useEffect, useState } from "react";
import { api } from "../lib/api";
import Panel from "../components/Panel";
import KpiCard from "../components/KpiCard";
import { fmtINR, fmtDate } from "../lib/format";
import ExportMenu from "../components/ExportMenu";

const STATUS_COLOR = { "Current": "#4af6c3", "Due": "#fb8b1e", "Overdue": "#ff433d" };

export default function Payables() {
    const [data, setData] = useState(null);
    useEffect(() => { api.get("/payables").then((r) => setData(r.data)); }, []);
    if (!data) return <div className="font-mono-fin text-sm text-[var(--text-secondary)]">// LOADING PAYABLES...</div>;

    return (
        <div className="space-y-4">
            <div className="flex items-start justify-between gap-3">
                <div>
                    <div className="font-mono-fin text-[10px] uppercase tracking-[0.25em] text-[var(--brand-amber)] mb-1">// PAYABLE MANAGEMENT</div>
                    <h1 className="font-display font-black text-3xl">Vendors & Subcontractors</h1>
                </div>
                <ExportMenu kind="ap" testId="export-ap" />
            </div>

            <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
                <KpiCard testId="ap-total" label="Total Outstanding" value={data.total} sub={`${data.invoices.length} bills`} accent />
                <KpiCard testId="ap-vendor-count" label="Active Vendors" value={data.vendors.length} format="custom" />
                <KpiCard testId="ap-current" label="0-30 Days" value={data.ageing["0-30"]} sub="Within terms" />
                <KpiCard testId="ap-overdue" label="Overdue >30d" value={data.ageing["31-60"] + data.ageing["61-90"] + data.ageing["90+"]} sub="Interest risk" />
            </div>

            <Panel testId="ap-vendor-summary" title="Vendor-wise Outstanding">
                <div className="overflow-x-auto">
                    <table className="w-full font-mono-fin text-xs">
                        <thead className="border-b border-panel">
                            <tr className="text-[10px] uppercase tracking-wider text-[var(--text-secondary)]">
                                <th className="text-left py-2">Vendor</th>
                                <th className="text-left">Category</th>
                                <th className="text-right">Rating</th>
                                <th className="text-right">Bills</th>
                                <th className="text-right">Outstanding</th>
                            </tr>
                        </thead>
                        <tbody>
                            {data.by_vendor.sort((a, b) => b.total - a.total).map((v) => (
                                <tr key={v.vendor_id} className="border-b border-[var(--border)]/50 hover:bg-[var(--bg-panel-hover)]">
                                    <td className="py-2 text-[var(--text-primary)]">{v.name}</td>
                                    <td><span className="text-[10px] uppercase tracking-wider px-1.5 py-0.5 border border-panel">{v.category}</span></td>
                                    <td className="text-right">
                                        <span className={v.rating >= 4 ? "text-pos" : v.rating >= 3 ? "text-amber" : "text-neg"}>{v.rating}</span>
                                    </td>
                                    <td className="text-right text-[var(--text-secondary)]">{v.count}</td>
                                    <td className="text-right text-amber">{fmtINR(v.total)}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </Panel>

            <Panel testId="ap-invoices" title="Bill Register">
                <div className="overflow-x-auto">
                    <table className="w-full font-mono-fin text-xs">
                        <thead className="border-b border-panel">
                            <tr className="text-[10px] uppercase tracking-wider text-[var(--text-secondary)]">
                                <th className="text-left py-2">Bill No</th>
                                <th className="text-left">Vendor</th>
                                <th className="text-left">Category</th>
                                <th className="text-right">Amount</th>
                                <th className="text-right">Due Date</th>
                                <th className="text-right">Overdue</th>
                                <th className="text-left">Status</th>
                            </tr>
                        </thead>
                        <tbody>
                            {data.invoices.map((p) => (
                                <tr key={p.id} className="border-b border-[var(--border)]/50 hover:bg-[var(--bg-panel-hover)]">
                                    <td className="py-2 text-[var(--text-primary)]">{p.invoice_no}</td>
                                    <td className="text-[var(--text-primary)]">{p.vendor_name}</td>
                                    <td className="text-[var(--text-secondary)] text-[10px] uppercase tracking-wider">{p.category}</td>
                                    <td className="text-right text-[var(--text-primary)]">{fmtINR(p.amount)}</td>
                                    <td className="text-right text-[var(--text-secondary)]">{fmtDate(p.due_date)}</td>
                                    <td className={`text-right ${p.days_overdue > 0 ? "text-neg" : "text-pos"}`}>{p.days_overdue > 0 ? `${p.days_overdue}d` : "—"}</td>
                                    <td><span className="text-[10px] uppercase tracking-wider px-1.5 py-0.5 border" style={{ borderColor: STATUS_COLOR[p.status] || "#E2E8F0", color: STATUS_COLOR[p.status] || "#8892B0" }}>{p.status}</span></td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </Panel>
        </div>
    );
}
